/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { ReactNode, PropsWithChildren } from 'react';

import { cn } from '@/utils';

type TimelineElementProps = {
    hideTimeline?: boolean;
    title: string | ReactNode;
};

const TimelineElement = ({ hideTimeline, title, children }: PropsWithChildren<TimelineElementProps>) => {
    return (
        <div className="flex gap-x-3">
            <div
                className={cn(
                    // eslint-disable-next-line max-len
                    'relative last:after:hidden after:absolute after:top-7 after:bottom-0 after:start-3.5 after:w-px after:-translate-x-[0.5px]',
                    hideTimeline ? 'after:bg -transparent' : 'after:bg-gray-200 dark:after:bg-neutral-700',
                )}
            >
                <div className="relative z-10 size-7 flex justify-center items-center">
                    <div className={`size-2 rounded-full bg-t bg-purple-500`} />
                </div>
            </div>

            <div className="grow pt-0.5 pb-8 max-w-[100%]">
                <h3 className="flex gap-x-1.5 font-semibold text-gray-800 dark:text-white">{title}</h3>
                <div className="mt-1 text-sm text-gray-600 dark:text-neutral-400">{children}</div>
            </div>
        </div>
    );
};

export default TimelineElement;
